import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/shared/Services/authentication.service';
import {Role} from '../../shared/Models/Role';
import { Helper } from 'src/app/helpers/helper.service';
import { Login } from '../model/Login';
import { TranslateService } from '@ngx-translate/core';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { StorageService } from 'src/app/auth/storage.service';

@Component({
  selector: 'undefined-verify-code',
  templateUrl: './verify-code.component.html',
  styleUrls: ['./verify-code.component.scss']
})
export class VerifyCodeComponent implements OnInit {

  public login: Login = new Login();
  loginInfo: any;
  public isSubmitting = false;

  constructor(
    private auth: AuthenticationService,
    private router: Router,
    private translateService: TranslateService,
    private reCaptchaV3Service: ReCaptchaV3Service,
    private helper: Helper,
    private storageService: StorageService
  ) {
  }

  ngOnInit() {
    if (!this.storageService.getData()) {
      this.router.navigateByUrl('');
    } else {
      this.login = this.storageService.getData();
    }
    localStorage.clear();
    document.querySelector('body').setAttribute('themebg-pattern', 'theme1');
    this.helper.removeHideRecaptchaBadgeClassToBody();
  }

  submitLogin() {
    this.isSubmitting = true;
    this.reCaptchaV3Service.execute('login').subscribe((token: string) => {
      this.login.recaptchaToken = token;
      this.auth.login(this.login).subscribe((result) => {
        this.isSubmitting = false;
        this.translateService.use(this.auth.getLocale());
        switch (result.roles[0]) {
          case Role.ROLE_BACK_OFFICE:
            this.router.navigateByUrl('/back-office/dashboard');
            break;
          case Role.ROLE_DEALER:
            this.router.navigateByUrl('/dealer-system/dashboard');
            break;
        }
      }, () => {
        this.isSubmitting = false;
      });
    }, () => {
      this.isSubmitting = false;
      this.helper.popMessageDialog(
        this.translateService.instant('errors.recaptcha.title'),
        this.translateService.instant('errors.recaptcha.failed'),
        'error',
        false,
      );
    });
  }

}
